<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">

      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addSoundFilePopup">{{ $t('add') }}</vs-button>
      </template>
      <vs-divider></vs-divider>

    </vx-card>

    <vx-card id="uploadSoundFileContainer" :title="$t('upload_sound_file')" class="mb-8 vs-con-loading__container">

      <shared-sound-file-list
        :soundFiles="soundFiles"
        @customClickDelete="deleteSoundFile"
      ></shared-sound-file-list>

      <template slot="footer">
        <paginate
          :total="soundFilePages"
          :click-handler="loadSoundFiles"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal :title="$t('Add Sound File')" id="addSoundFile" :active.sync="modals.add" size="xl">
      <shared-sound-file-add
        @addSoundFileSuccess="addSoundFileSuccess"
      ></shared-sound-file-add>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="addSoundFileButton" color="primary" type="filled" @click.prevent="addSoundFile">{{ $t('save') }}</vs-button>
      </div>
    </modal>

  </div>
</template>

<script>
import SoundFile from '@/models/SoundFile'
import Paginate from '@/mixins/paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedSoundFileList from '@/views/Shared/SoundFiles/List'
import SharedSoundFileAdd from '@/views/Shared/SoundFiles/Add'

export default {
  name: 'User.SoundFiles',
  mixins: [Paginate],
  components: {
    SharedSoundFileList,
    SharedSoundFileAdd,
    Modal
  },
  data () {
    return {
      soundFiles: {},
      soundFilePages: 0,
      soundFileSearchParams: [],
      modals: {
        add: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initSoundFileFormData')
      }
    }
  },
  mounted () {
    this.loadSoundFiles(this.initialPage)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_sound_file_table', this.reloadSoundFiles)
  },
  methods: {
    reloadSoundFiles () {
      this.loadSoundFiles(this.initialPage)
    },
    async loadSoundFiles (page = 1, backToPageOne = false) {
      this.$vs.loading({container: '#uploadSoundFileContainer'})

      const response = await SoundFile.all({ ...this.soundFileSearchParams, page })
      this.soundFiles = response.data.data.soundFiles
      this.soundFilePages = response.data.meta.pagination.last_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#uploadSoundFileContainer > .con-vs-loading')
    },
    addSoundFile () {
      EventBus.$emit('initAddSoundFile')
    },
    addSoundFileModal () {
      this.modals.add = true
    },
    addSoundFilePopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-sound-file', {}, this.addSoundFileModal)
    },
    addSoundFileSuccess () {
      this.loadSoundFiles(this.initialPage)
      this.modals.add = false
    },
    async deleteSoundFile (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          await SoundFile.destroy({ id })
          this.loadSoundFiles()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }

      }
    }
  }
}
</script>

<style lang="scss">

</style>
